import { envForSpawn, substituteCommand } from '../env.js';
import {
  emptyPreviewEnvironmentLogTails,
  sendPreviewEnvironmentManagerStatus,
} from '../state.js';
import type { PreviewEnvironmentManagerRuntime } from '../runtime.js';
import type { BridgePreviewEnvironmentDef } from '../types.js';

export type PreparedPreviewEnvironmentStart = {
  cwd: string;
  childEnv: NodeJS.ProcessEnv;
  cmd: string;
  title: string;
  scheduledGen: number;
  ac: AbortController;
};

export function preparePreviewEnvironmentStart(
  runtime: PreviewEnvironmentManagerRuntime,
  environmentId: string,
  def: BridgePreviewEnvironmentDef,
): PreparedPreviewEnvironmentStart {
  const { state, getWs, log, getBridgeRoot, getPreviewWorktreeParentPath } = runtime;

  sendPreviewEnvironmentManagerStatus(getWs, environmentId, 'starting', undefined, emptyPreviewEnvironmentLogTails());

  const ac = new AbortController();
  state.abortControllersByServerId.set(environmentId, ac);

  const bridgeRoot = getBridgeRoot();
  const previewParentPath = getPreviewWorktreeParentPath?.(environmentId);
  const cwd = previewParentPath ?? bridgeRoot;
  const childEnv = envForSpawn(process.env as NodeJS.ProcessEnv, def.env, def.ports);
  const cmd = substituteCommand(def.command.trim(), childEnv);
  const title = def.name.trim() || environmentId.slice(0, 8);
  log(`[preview-environment] Starting ${title}: ${cmd.slice(0, 120)}${cmd.length > 120 ? '…' : ''}`);

  return {
    cwd,
    childEnv,
    cmd,
    title,
    scheduledGen: state.spawnGenerationByServerId.get(environmentId) ?? 0,
    ac,
  };
}
